module.exports = __webpack_public_path__ + "img/jmsq.085d77e2.png";